export class ServiceUnavailableError extends Error {
  code = 503;

  constructor() {
    super();
  }
}
